import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'
import { jwtDecode } from 'jwt-decode'

export default {
    namespaced: true,
    state: {
        user: {},
        lstUsers: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'USUÁRIO', key: 'userName', align: 'center' }
        ],
        token: null,
        lstPermissionsLoggedUser: [],
        userId: null,
        permissionsMap: [
            { label: 'Venda', code: 'SALE' },
            { label: 'Transferência', code: 'TRANSFER' },
            { label: 'Clientes', code: 'CUSTOMER' },
            { label: 'Estoques', code: 'STOCK' },
            { label: 'Produtos', code: 'PRODUCT' },
            { label: 'Categorias', code: 'CATEGORY' },
            { label: 'Potes', code: 'POT' },
            { label: 'Pagamentos', code: 'PAYMENT' },
            { label: 'Usuários', code: 'USER' },
            { label: 'Vendedores', code: 'SELLER' },
            { label: 'Estoque', code: 'STOCK_RELAT', section: 'report' },
            { label: 'Vendas', code: 'SALE_RELAT', section: 'report' }
        ],
        isSuperAdmin: false
    },
    getters: {
        getUser(state) {
            let user = { ...state.user }
            return user
        },
        hasPermission: (state) => (permission) => {
            if (state.isSuperAdmin)
                return true

            return state.lstPermissionsLoggedUser.includes(permission)
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setLstUsers(state, lstUsers) {
            state.lstUsers = lstUsers
        },
        appendLstUsers(state, items) {
            state.lstUsers = [...state.lstUsers, ...items]
        },
        clearLstUsers(state) {
            state.lstUsers = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.user = {
                permissions: []
            }
            state.permission = []
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        },
        setToken(state, token) {
            state.token = token
        },
        setUserId(state, userId) {
            state.userId = userId
        },
        setLstPermissionsLoggedUser(state, lstPermissionsLoggedUser) {
            state.lstPermissionsLoggedUser = lstPermissionsLoggedUser
        },
        logout(state) {
            state.token = null,
            state.userId = null,
            state.lstPermissionsLoggedUser = []
        },
        setIsSuperAdmin(state, value) {
            state.isSuperAdmin = value
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Users/Insert',
                getters.getUser
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Usuario salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Users/Update',
                getters.getUser
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Usuário atualizado'
            }, { root: true })

            return true
        },

        async findAll({commit}) {
            const response = await api.get(
                '/Users/FindAll'
            )
            commit('setLstUsers', response.data)

            return true
        },

        async findExistentUser() {
            const response = await api.get(
                '/Users/FindExistentUser'
            )

            return response.data
        },

        async search({ state, commit }, { search, limit = 20, page = 1, reset }) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Users/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstUsers", response.data.items)
            } else {
                commit("appendLstUsers", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, userId) {
            const response = await api.get(
                `/Users/Find/${userId}`,
            )

            commit('setUser', response.data)
            commit('setUpdating')

            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Users/delete/${getters.getUser.userId}`,
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        },

        async login({ state, getters, dispatch }, password) {
            const payload = {
                UserId: getters.getUser.userId,
                UserPassword: password
            }
            
            const response = await api.post(
                '/Users/Login/',
                payload
            )

            const token = response.data?.token
            
            if (!token) 
                return false


            localStorage.setItem('token', token)
            dispatch('setPermissionByToken', token)
            
            const user = state.lstUsers.find(
                u => u.userId === getters.getUser.userId
            )
            localStorage.setItem('usuario', user.userName)
            
            return true
        },
        
        setPermissionByToken({ commit }, token) {
            commit('setToken', token)

            const decoded = jwtDecode(token)

            commit('setUserId', decoded.userId)

            commit('setLstPermissionsLoggedUser', decoded.permission ?? [])
            commit('setIsSuperAdmin', decoded.isSuperAdmin === 'true')
        },

        loadFromStorage({ commit }) {
            const token = localStorage.getItem('token')
            if (!token) return

            const decoded = jwtDecode(token)

            commit('setToken', token)
            commit('setUserId', decoded.userId)
            commit('setLstPermissionsLoggedUser', decoded.permission || [])
        },

        logout({ commit }) {
            commit('setToken', null)
            commit('setUserId', null)
            commit('setLstPermissionsLoggedUser', [])
            localStorage.removeItem('token')
            localStorage.removeItem('usuario')
        }

    }
}